module.exports = __webpack_public_path__ + "img/icon_e61.2580b063.png";